import { useEffect, useState } from 'react';
import { buildDidYouMean } from '@coveo/headless';
import headlessEngine from 'lib/utils/coveo/headlessEngine';
import { isEditorActive, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

const useDidYouMean = () => {
  const controller = buildDidYouMean(headlessEngine, {
    options: { queryCorrectionMode: 'legacy' },
  });
  const [state, setState] = useState(controller.state);
  const { sitecoreContext } = useSitecoreContext();

  useEffect(() => {
    if (isEditorActive() || sitecoreContext?.pageState === 'preview') {
      return;
    }
    controller.subscribe(() => setState(controller.state));
  }, []);

  return state;
};

export default useDidYouMean;
